/**
 * Date-extensions locale Bengali [bn]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('bn', {
    monthNames: ['জানুয়ারী','ফেব্রুয়ারি','মার্চ','এপ্রিল','মে','জুন','জুলাই','আগস্ট','সেপ্টেম্বর','অক্টোবর','নভেম্বর','ডিসেম্বর'],
    monthShortNames: ['জানু','ফেব','মার্চ','এপ্র','মে','জুন','জুল','আগ','সেপ্ট','অক্টো','নভে','ডিসে'],
    dayNames: ['রবিবার','সোমবার','মঙ্গলবার','বুধবার','বৃহস্পতিবার','শুক্রবার','শনিবার'],
    dayShortNames: ['রবি','সোম','মঙ্গল','বুধ','বৃহস্পতি','শুক্র','শনি']
});
